export class SelObTypes {
    public static TEXT = "text";
    public static LOGO = "logo";
    public static STOCKLOGO = "stocklogo";
    public static CHROMOLOGO = "chromologo";
    public static PATTERN = "pattern";

    public static isLogo = type=>[SelObTypes.LOGO, SelObTypes.CHROMOLOGO, SelObTypes.STOCKLOGO].indexOf(type)>-1;
    public static isEinfaerbbaresLogo = type=>[SelObTypes.CHROMOLOGO, SelObTypes.STOCKLOGO].indexOf(type)>-1;

}
